<script>
import Drawer from "@/components/drawer";

// Custom components
import PageHeader from "@/components/page-header";
import intentAddEditDrawer from "@/components/superAdmin/videoBot/avatar/intentAddEditDrawer.vue";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    title: "List Of Intents",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "List Of Intents",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Avatar Intent",
          active: true,
        },
      ],
      addEditIntent: false,
      openNewRequestForm: false,
      isEdit: false,
      isEditable: true,
      tableData: [],
      hotels: [],
      updateValue: "",
      isDataLoading: false,
      is_btn_loading: false,
      avatarId: "",
      avatarName: "",
      avatarImage: "",
      selected: "all",
      isBtnLoading: false,
      tempHotelList: [],
      allCheck: 1,
      sortedbyASC: true,
    };
  },
  components: {
    PageHeader,
    Drawer,
    intentAddEditDrawer,
  },
  computed: {
    ...authComputed,
    intentProps() {
      return {
        isEdit: this.isEdit,
        updateValue: this.updateValue,
        isEditable: this.isEditable,
        avatarId: this.avatarId,
        avatarName: this.avatarName,
      };
    },
  },
  mounted() {
    this.getAvatarDetails();
    this.getHotelList();
  },
  watch: {
    $route(to, from) {
      this.getAvatarDetails();
    },
  },

  methods: {
    getHotelList() {
      UserService.getVideoChatHotelList().then((result) => {
        this.hotels = result.hotelList;
      });
    },

    // Get list of all intents
    async getAvatarDetails() {
      this.isDataLoading = true;

      if (this.$route.query.avatar_id != undefined) {
        await UserService.getBotAvatarDetails(this.$route.query.avatar_id).then(
          (result) => {
            this.avatarName = result.name;
            this.avatarId = result.id;
            this.avatarImage =
              "https://vod-lex-files.s3.amazonaws.com/" + result.photo;
            delete result.gender;
            delete result.photo;
            delete result.name;
            delete result.id;
            delete result.idle_video;
            delete result.fallback_video;
            delete result.fallback_reply;

            let tempResult = [];
            for (const key in result) {
              tempResult.push(result[key]);
            }

            this.tableData = tempResult;
            this.tableData.sort((x, y) => (x["name"] < y["name"] ? -1 : 1));
          }
        );
      }

      this.isDataLoading = false;
    },

    addEditIntentDrawer() {
      if (this.addEditIntent === true) {
        this.isEdit = false;
        this.updateValue = "";
      }
      this.addEditIntent = !this.addEditIntent;
    },

    intentAddedUpdated(data, isEdit) {
      this.hotels.map((item) => {
        UserService.getVideoChatHotelDetails(item.hotel_id).then((result) => {
          if (this.avatarId === result.id) {
            data = {
              ...data,
              hotel_id: item.hotel_id,
            };
            UserService.addUpdateVideoChatHotelIntent(data).then((res) => {
              console.log(res, "resres");
            });
          }
        });
      });
      this.getAvatarDetails();
      this.addEditIntentDrawer();
    },

    saveAndAddNewIntent(data) {
      this.tableData.push(data);
      this.addEditIntentDrawer();
    },

    editIntent(data, type, index) {
      if (type == false) {
        this.isEditable = false;
      }
      this.isEdit = true;
      this.updateValue = data;
      this.addEditIntentDrawer();
    },

    async deployAvatarIntent() {
      this.tempHotelList = [];
      this.isBtnLoading = true;
      await UserService.getVideoChatHotelList()
        .then((hotel) => {
          hotel.hotelList.map(async (item) => {
            await UserService.getVideoChatHotelDetails(item.hotel_id).then(
              (hotelDetails) => {
                if (
                  hotelDetails.id != undefined &&
                  this.avatarId == hotelDetails.id
                ) {
                  this.tempHotelList.push({
                    hotel_id: hotelDetails.hotel_id,
                    hotel_name: hotelDetails.hotel_name,
                    is_checked: 1,
                  });
                  this.isBtnLoading = false;
                }
              }
            );
          });
          this.$refs["hotel_selection_modal"].show();
        })
        .catch((error) => {
          this.isBtnLoading = false;
          errorHandler(error);

          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
    },

    allChecked(check) {
      if (check) {
        this.tempHotelList.map((item) => {
          item.is_checked = 1;
        });
      } else {
        this.tempHotelList.map((item) => {
          item.is_checked = 0;
        });
      }
    },

    singleCheck(index, isChecked) {
      let check = [];
      this.tempHotelList[index].is_checked = !isChecked;
      this.tempHotelList.map((item) => {
        if (item.is_checked) {
          check.push(item);
        }
      });
      if (check.length == this.tempHotelList.length) {
        this.allCheck = 1;
      } else {
        this.allCheck = 0;
      }
    },

    async updateIntentIntoAvatar() {
      this.isBtnLoading = true;
      await UserService.getBotAvatarDetails(this.avatarId)
        .then((avatar) => {
          let tempObj = {};
          this.tempHotelList.map(async (item) => {
            if (item.is_checked) {
              UserService.getVideoChatHotelDetails(item.hotel_id).then(
                async (hotelDetails) => {
                  delete hotelDetails.hotel_name;
                  delete hotelDetails.hotel_id;
                  delete hotelDetails.fallback_reply;
                  delete hotelDetails.fallback_video;
                  delete hotelDetails.gender;
                  delete hotelDetails.idle_video;
                  delete hotelDetails.id;
                  delete hotelDetails.name;
                  delete hotelDetails.photo;

                  for (const index in avatar) {
                    if (avatar[index].is_common != undefined) {
                      let avatarTempObj = {};
                      avatarTempObj[avatar[index].name] = {
                        audio_file: avatar[index].audio_file,
                        name: avatar[index].name,
                        id: avatar[index].id,
                        video_file: avatar[index].video_file,
                        text_reply: avatar[index].text_reply,
                        video_file_duration: avatar[index].video_file_duration,
                        slot_cmd: avatar[index].slot_cmd,
                        is_common: false,
                      };

                      avatarTempObj = {
                        ...avatarTempObj,
                        id: avatar.id,
                      };
                      UserService.addUpdateBotAvatarIntent(avatarTempObj);
                    }
                    // if (hotelDetails[index] == undefined) {
                    tempObj[avatar[index].name] = {
                      audio_file: avatar[index].audio_file,
                      name: avatar[index].name,
                      id: avatar[index].id,
                      video_file: avatar[index].video_file,
                      text_reply: avatar[index].text_reply,
                      video_file_duration: avatar[index].video_file_duration,
                      slot_cmd: avatar[index].slot_cmd,
                      // };
                    };
                  }

                  tempObj = {
                    ...tempObj,
                    id: this.avatarId,
                  };

                  delete tempObj.id;
                  tempObj = {
                    ...tempObj,
                    hotel_id: item.hotel_id,
                  };
                  await UserService.addUpdateVideoChatHotelIntent(tempObj).then(
                    (response) => {
                      delete tempObj.hotel_id;
                      this.getAvatarDetails();
                      this.$refs["hotel_selection_modal"].hide();
                      this.isBtnLoading = false;
                      Middleware.notification(
                        "Successfully deployed !!",
                        "success"
                      );
                    }
                  );
                }
              );
            }
          });
        })
        .catch((error) => {
          this.isBtnLoading = false;
          errorHandler(error);
          Middleware.notification("Something went wrong !!", "success");

          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
    },

    sortList(sortBy) {
      if (this.sortedbyASC) {
        this.tableData.sort((x, y) => (x[sortBy] > y[sortBy] ? -1 : 1));
        this.sortedbyASC = false;
      } else {
        this.tableData.sort((x, y) => (x[sortBy] < y[sortBy] ? -1 : 1));
        this.sortedbyASC = true;
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="avatarName ? '' + avatarName + ' for ' + title : 'All ' + title"
      :items="items"
      :action="addEditIntentDrawer"
      text="Add New"
      :isButton="false"
    />

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12 float-end">
            <b-button
              class="mb-2"
              variant="outline-primary"
              type="button"
              :class="{ disabled: isBtnLoading }"
              @click="deployAvatarIntent"
            >
              <i
                v-if="isBtnLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i>
              Deploy</b-button
            >
          </div>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead class="table-light">
              <tr>
                <th @click="sortList('name')">Intent &#8597;</th>
                <th class="w-500">Reply</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody v-if="isDataLoading">
              <tr v-for="(item, index) in 10" :key="index">
                <td class="placeholder-glow" v-for="no in 4" :key="no">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr
                v-for="(data, index) in tableData"
                :key="data.id"
                :class="[data.is_common == true ? 'bg-danger text-white' : '']"
              >
                <td @click="openBotDrawer(data.id, index)">
                  {{ data.name }}
                </td>

                <td class="text-wrap w-500">
                  <p class="mb-0">
                    {{ data.text_reply == "" ? "-" : data.text_reply }}
                  </p>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <i
                      class="fas fa-microphone-alt fs-5 me-2"
                      :class="[
                        data.audio_file == '' ? 'text-muted' : 'text-success',
                      ]"
                    ></i>
                    <i
                      class="fas fa-video fs-5 mx-2"
                      :class="[
                        data.video_file == '' ? 'text-muted' : 'text-success',
                      ]"
                    ></i>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <i
                      class="fas fa-pencil-alt text-success fs-5"
                      @click="editIntent(data, false)"
                    ></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Drawer -->
    <Drawer
      @close="addEditIntentDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="addEditIntent">
        <intentAddEditDrawer
          :currentProps="intentProps"
          @submitted="intentAddedUpdated"
          @cancelSubmit="addEditIntentDrawer"
          @saveAndAddNew="saveAndAddNewIntent"
        ></intentAddEditDrawer>
      </div>
    </Drawer>

    <b-modal
      id="modal-"
      size="lg"
      ref="hotel_selection_modal"
      title=""
      title-class="font-18"
      headerClass="justify-content-center"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <table class="table">
              <thead class="table-light">
                <tr>
                  <th>
                    <div class="form-check form-check-right mb-3">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="all"
                        v-model="allCheck"
                        @click="allChecked(!allCheck)"
                      />
                      <label class="form-check-label" for="all"> </label>
                    </div>
                  </th>
                  <th>Hotel ID</th>
                  <th>Hotel Name</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in tempHotelList" :key="index">
                  <td>
                    <div class="form-check form-check-right mb-3">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="'checkbox_' + index"
                        v-model="item.is_checked"
                        @click="singleCheck(index, item.is_checked)"
                      />
                      <label class="form-check-label" :for="index"> </label>
                    </div>
                  </td>
                  <td>{{ item.hotel_id }}</td>
                  <td>{{ item.hotel_name }}</td>
                </tr>
              </tbody>
            </table>

            <b-button
              class="mb-2 text-center mx-auto float-end float-right"
              variant="outline-primary"
              type="button"
              :class="{ disabled: isBtnLoading }"
              @click="updateIntentIntoAvatar"
            >
              <i
                v-if="isBtnLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i>
              Update</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.w-500 {
  width: 500px;
}
</style>
